import { useTranslation } from 'react-i18next'

export const SwitchReportedImageContent = (status?: string) => {
  const { t } = useTranslation()

  const REPORTED_IMAGE_ENUM = {
    ACCEPTED: 'ACCEPTED',
    WAITING_FEEDBACK: 'WAITING FEEDBACK',
    USER_ACTION: 'USER ACTION',
    FAILED: 'FAILED',
    REMOVE: 'REMOVE',
    REQUEST_DENIED: 'REQUEST DENIED',
    SOLVED: 'SOLVED',
    PENDING: 'PENDING',
  }

  const notificationReportedObject = {
    title: '',
    description: '',
  }

  switch (status) {
    case REPORTED_IMAGE_ENUM.ACCEPTED:
      notificationReportedObject.title = t('notifications.reportStatusNotification.accepted.title')
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.accepted.description',
      )
      break
    case REPORTED_IMAGE_ENUM.WAITING_FEEDBACK:
      notificationReportedObject.title = t(
        'notifications.reportStatusNotification.waitingFeedback.title',
      )
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.waitingFeedback.description',
      )
      break
    case REPORTED_IMAGE_ENUM.FAILED:
      notificationReportedObject.title = t('notifications.reportStatusNotification.failed.title')
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.failed.description',
      )
      break
    case REPORTED_IMAGE_ENUM.REMOVE:
      notificationReportedObject.title = t('notifications.reportStatusNotification.remove.title')
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.remove.description',
      )
      break
    case REPORTED_IMAGE_ENUM.REQUEST_DENIED:
      notificationReportedObject.title = t(
        'notifications.reportStatusNotification.requestDenied.title',
      )
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.requestDenied.description',
      )
      break
    case REPORTED_IMAGE_ENUM.SOLVED:
      notificationReportedObject.title = t('notifications.reportStatusNotification.solved.title')
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.solved.description',
      )
      break
    case REPORTED_IMAGE_ENUM.PENDING:
      notificationReportedObject.title = t('notifications.reportStatusNotification.pending.title')
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.pending.description',
      )
      break
    case REPORTED_IMAGE_ENUM.USER_ACTION:
      notificationReportedObject.title = t(
        'notifications.reportStatusNotification.userAction.title',
      )
      notificationReportedObject.description = t(
        'notifications.reportStatusNotification.userAction.description',
      )
      break

    default:
      break
  }

  return notificationReportedObject
}
